(() => {
  const selector = '.pdp__add, .pdp__sticky, .clip-primary, form[action*="/cart/add"] button[type="submit"]';
  const gap = 12;
  let frame = 0;
  let host;
  let shadowObserver;
  let observedRoot;
  const observed = new WeakSet();

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const resizeObserver = new ResizeObserver(schedule);
  const mutationObserver = new MutationObserver(schedule);

  function update() {
    frame = 0;
    const nextHost = document.querySelector('logos-customer-chat');
    if (nextHost !== host) {
      shadowObserver?.disconnect();
      host = nextHost;
      observedRoot = null;
    }
    if (host?.shadowRoot && observedRoot !== host.shadowRoot) {
      observedRoot = host.shadowRoot;
      shadowObserver = new MutationObserver(schedule);
      shadowObserver.observe(observedRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden', 'class'] });
    }
    const launcher = host?.shadowRoot?.querySelector('.launcher');
    if (!launcher || launcher.hidden || !launcher.getClientRects().length) return;

    const viewport = { width: document.documentElement.clientWidth, height: window.innerHeight };
    const current = parseFloat(getComputedStyle(host).getPropertyValue('--chat-cart-clearance')) || 0;
    const actual = launcher.getBoundingClientRect();
    const base = { left: actual.left, right: actual.right, top: actual.top + current, bottom: actual.bottom + current };
    const obstacles = [];
    let animating = false;
    for (const element of document.querySelectorAll(selector)) {
      animating ||= element.getAnimations().some(animation => animation.playState === 'running');
      if (!observed.has(element)) {
        resizeObserver.observe(element);
        observed.add(element);
      }
      const style = getComputedStyle(element);
      if (style.display === 'none' || style.visibility !== 'visible' || Number(style.opacity) === 0) continue;
      const rect = element.getBoundingClientRect();
      if (!rect.width || !rect.height || rect.bottom <= 0 || rect.top >= viewport.height || rect.right <= 0 || rect.left >= viewport.width) continue;
      if (base.right + gap <= rect.left || base.left - gap >= rect.right) continue;
      obstacles.push(rect);
    }
    obstacles.sort((a, b) => b.top - a.top);
    let clearance = 0;
    for (const rect of obstacles) {
      if (base.bottom - clearance + gap > rect.top && base.top - clearance - gap < rect.bottom) {
        clearance = Math.max(clearance, base.bottom - rect.top + gap);
      }
    }
    const value = `${Math.ceil(clearance)}px`;
    if (host.style.getPropertyValue('--chat-cart-clearance') !== value) {
      host.style.setProperty('--chat-cart-clearance', value);
    }
    if (animating) schedule();
  }

  mutationObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden', 'aria-hidden'] });
  resizeObserver.observe(document.body);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule, { once: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('transitionend', schedule, true);
  document.addEventListener('transitionrun', schedule, true);
  document.fonts?.ready.then(schedule);
  customElements.whenDefined('logos-customer-chat').then(schedule);
  schedule();
})();
